"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// packages/ag-charts-locale/src/ko-KR.ts
var ko_KR_exports = {};
__export(ko_KR_exports, {
  AG_CHARTS_LOCALE_KO_KR: () => AG_CHARTS_LOCALE_KO_KR
});
module.exports = __toCommonJS(ko_KR_exports);
var AG_CHARTS_LOCALE_KO_KR = {
  ariaAnnounceChart: "\uCC28\uD2B8, ${seriesCount}[number] \uC2DC\uB9AC\uC988",
  ariaAnnounceFlowProportionLink: "\uB9C1\uD06C ${index} / ${count}, ${from}\uC5D0\uC11C ${to}\uB85C, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "\uB178\uB4DC ${index} / ${count}, ${description}",
  ariaAnnounceGaugeChart: "\uAC8C\uC774\uC9C0 \uCC28\uD2B8, ${caption}",
  ariaAnnounceHierarchyChart: "\uACC4\uCE35 \uCC28\uD2B8, ${caption}",
  ariaAnnounceHierarchyDatum: "\uB808\uBCA8 ${level}[number], ${count}[number] \uC790\uC2DD, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "\uC2A4\uD398\uC774\uC2A4\uBC14 \uB610\uB294 \uC5D4\uD130\uB97C \uB20C\uB7EC \uD45C\uC2DC \uC5EC\uBD80\uB97C \uC804\uD658\uD558\uC138\uC694",
  ariaLabelAddHorizontalLine: "\uC218\uD3C9\uC120 \uCD94\uAC00",
  ariaLabelAnnotationOptionsToolbar: "\uC8FC\uC11D \uC635\uC158",
  ariaLabelAnnotationSettingsDialog: "\uC8FC\uC11D \uC124\uC815",
  ariaLabelColorPicker: "\uC0C9\uC0C1 \uC120\uD0DD\uAE30",
  ariaLabelFinancialCharts: "\uAE08\uC735 \uCC28\uD2B8",
  ariaLabelLegend: "\uBC94\uB840",
  ariaLabelLegendItem: "${label}, \uBC94\uB840 \uD56D\uBAA9 ${index}[number] / ${count}[number]",
  ariaLabelLegendItemUnknown: "\uC54C \uC218 \uC5C6\uB294 \uBC94\uB840 \uD56D\uBAA9",
  ariaLabelLegendPageNext: "\uB2E4\uC74C \uBC94\uB840 \uD398\uC774\uC9C0",
  ariaLabelLegendPagePrevious: "\uC774\uC804 \uBC94\uB840 \uD398\uC774\uC9C0",
  ariaLabelLegendPagination: "\uBC94\uB840 \uD398\uC774\uC9C0 \uB9E4\uAE40",
  ariaLabelNavigator: "\uB124\uBE44\uAC8C\uC774\uD130",
  ariaLabelNavigatorMaximum: "\uCD5C\uB300",
  ariaLabelNavigatorMinimum: "\uCD5C\uC18C",
  ariaLabelNavigatorRange: "\uBC94\uC704",
  ariaLabelRangesToolbar: "\uBC94\uC704",
  ariaLabelSettingsTabBar: "\uC124\uC815",
  ariaLabelZoomToolbar: "\uD655\uB300",
  ariaValuePanRange: "${min}[percent0to2dp]\uC5D0\uC11C ${max}[percent0to2dp]\uAE4C\uC9C0",
  contextMenuDownload: "\uB2E4\uC6B4\uB85C\uB4DC",
  contextMenuPanToCursor: "\uC5EC\uAE30\uB85C \uC774\uB3D9",
  contextMenuToggleOtherSeries: "\uB2E4\uB978 \uACC4\uC5F4 \uC804\uD658",
  contextMenuToggleSeriesVisibility: "\uAC00\uC2DC\uC131 \uC804\uD658",
  contextMenuZoomToCursor: "\uC5EC\uAE30\uB85C \uD655\uB300",
  dialogHeaderChannel: "\uCC44\uB110",
  dialogHeaderDatePriceRange: "\uB0A0\uC9DC \uBC0F \uAC00\uACA9",
  dialogHeaderDateRange: "\uB0A0\uC9DC \uBC94\uC704",
  dialogHeaderFibonacciRange: "\uD53C\uBCF4\uB098\uCE58 \uB418\uB3CC\uB9BC",
  dialogHeaderLine: "\uB77C\uC778",
  dialogHeaderPriceRange: "\uAC00\uACA9 \uBC94\uC704",
  dialogHeaderText: "\uD14D\uC2A4\uD2B8",
  dialogInputAlign: "\uC815\uB82C",
  dialogInputColorPicker: "\uC0C9\uC0C1",
  dialogInputColorPickerAltText: "\uD14D\uC2A4\uD2B8 \uC0C9\uC0C1",
  dialogInputExtendAbove: "\uC704\uB85C \uD655\uC7A5",
  dialogInputExtendBelow: "\uC544\uB798\uB85C \uD655\uC7A5\uD558\uAE30",
  dialogInputExtendChannelEnd: "\uCC44\uB110 \uB05D \uD655\uC7A5",
  dialogInputExtendChannelStart: "\uCC44\uB110 \uC2DC\uC791 \uD655\uC7A5",
  dialogInputExtendLeft: "\uC67C\uCABD\uC73C\uB85C \uD655\uC7A5",
  dialogInputExtendLineEnd: "\uC120 \uB05D \uC5F0\uC7A5",
  dialogInputExtendLineStart: "\uC120 \uC2DC\uC791 \uD655\uC7A5",
  dialogInputExtendRight: "\uC624\uB978\uCABD \uD655\uC7A5",
  dialogInputFibonacciBands: "\uBC34\uB4DC",
  dialogInputFibonacciBandsAltText: "\uD53C\uBCF4\uB098\uCE58 \uBC34\uB4DC",
  dialogInputFillColorPicker: "\uC0C9 \uCC44\uC6B0\uAE30",
  dialogInputFillColorPickerAltText: "\uCC44\uC6B0\uAE30 \uC0C9\uC0C1",
  dialogInputFontSize: "\uD06C\uAE30",
  dialogInputFontSizeAltText: "\uAE00\uAF34 \uD06C\uAE30",
  dialogInputLineStyle: "\uB300\uC2DC",
  dialogInputPosition: "\uC704\uCE58",
  dialogInputReverse: '"\uBC18\uC804"',
  dialogInputShowFill: "\uCC44\uC6B0\uAE30 \uD45C\uC2DC",
  dialogInputStrokeWidth: "\uAD75\uAE30",
  dialogInputStrokeWidthAltText: "\uC120 \uAD75\uAE30",
  iconAltTextAlignCenter: "\uAC00\uC6B4\uB370 \uB9DE\uCDA4",
  iconAltTextAlignLeft: "\uC67C\uCABD",
  iconAltTextAlignRight: "\uC624\uB978\uCABD",
  iconAltTextClose: "\uB2EB\uAE30",
  iconAltTextLineStyleDashed: "\uAE34 \uB300\uC2DC",
  iconAltTextLineStyleDotted: "\u2018\uC9E7\uC740 \uB300\uC2DC\u2019",
  iconAltTextLineStyleSolid: "\uC2E4\uC120",
  iconAltTextPositionBottom: "\uC544\uB798\uCABD",
  iconAltTextPositionCenter: "\uC911\uC559",
  iconAltTextPositionTop: "\uC704",
  inputTextareaPlaceholder: "\uD14D\uC2A4\uD2B8 \uCD94\uAC00",
  measurerDateRangeBars: "${value}[number] \uB9C9\uB300",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "\uC6A9\uB7C9 ${value}",
  overlayLoadingData: "\uB370\uC774\uD130\uB97C \uB85C\uB4DC\uD558\uB294 \uC911...",
  overlayNoData: "\uD45C\uC2DC\uD560 \uB370\uC774\uD130\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4",
  overlayNoVisibleSeries: "\uBCF4\uC774\uB294 \uC2DC\uB9AC\uC988\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4",
  overlayUnsupportedBrowser: "\uD638\uD658\uB418\uC9C0 \uC54A\uB294 \uBE0C\uB77C\uC6B0\uC800 \uBC84\uC804\uC785\uB2C8\uB2E4. \uBE0C\uB77C\uC6B0\uC800\uB97C \uC5C5\uADF8\uB808\uC774\uB4DC\uD574 \uC8FC\uC2ED\uC2DC\uC624.",
  seriesHistogramTooltipCount: "${yName} (\uAC1C\uC218)",
  seriesHistogramTooltipFrequency: "\uBE48\uB3C4",
  seriesHistogramTooltipMean: "${yName} (\uD3C9\uADE0)",
  seriesHistogramTooltipSum: "${yName} (\uD569\uACC4)",
  toolbarAnnotationsArrow: "\uD654\uC0B4\uD45C",
  toolbarAnnotationsArrowDown: "\uC544\uB798\uCABD \uD654\uC0B4\uD45C",
  toolbarAnnotationsArrowUp: "\uC704\uCABD \uD654\uC0B4\uD45C",
  toolbarAnnotationsCallout: "\uCF5C\uC544\uC6C3",
  toolbarAnnotationsClearAll: "\uBAA8\uB450 \uC9C0\uC6B0\uAE30",
  toolbarAnnotationsComment: "\uB313\uAE00",
  toolbarAnnotationsDatePriceRange: "\uB0A0\uC9DC \uBC0F \uAC00\uACA9",
  toolbarAnnotationsDateRange: "\uB0A0\uC9DC \uBC94\uC704",
  toolbarAnnotationsDelete: "\uC0AD\uC81C",
  toolbarAnnotationsDisjointChannel: "\uB3C5\uB9BD \uCC44\uB110",
  toolbarAnnotationsDragHandle: "\uB3C4\uAD6C \uBAA8\uC74C \uB04C\uAE30",
  toolbarAnnotationsFibonacciAnnotations: "\uD53C\uBCF4\uB098\uCE58",
  toolbarAnnotationsFibonacciRetracement: "\uD53C\uBCF4\uB098\uCE58 \uB418\uB3CC\uB9BC",
  toolbarAnnotationsFibonacciRetracementTrendBased: "\uD53C\uBCF4\uB098\uCE58 \uCD94\uC138 \uAE30\uBC18",
  toolbarAnnotationsFillColor: "\uCC44\uC6B0\uAE30 \uC0C9\uC0C1",
  toolbarAnnotationsHorizontalLine: "\uC218\uD3C9\uC120",
  toolbarAnnotationsLineAnnotations: "\uCD94\uC138\uC120",
  toolbarAnnotationsLineColor: "\uC120 \uC0C9\uC0C1",
  toolbarAnnotationsLineStrokeWidth: "\uC120 \uD68D \uB108\uBE44",
  toolbarAnnotationsLineStyle: "\uC120 \uC2A4\uD0C0\uC77C",
  toolbarAnnotationsLock: "\uC7A0\uAE08",
  toolbarAnnotationsMeasurerAnnotations: "\uCE21\uC815\uAE30",
  toolbarAnnotationsNote: "\uB178\uD2B8",
  toolbarAnnotationsParallelChannel: "\uD3C9\uD589 \uCC44\uB110",
  toolbarAnnotationsPriceRange: "\uAC00\uACA9 \uBC94\uC704",
  toolbarAnnotationsQuickDatePriceRange: "\uCE21\uC815",
  toolbarAnnotationsSettings: "\uC124\uC815",
  toolbarAnnotationsShapeAnnotations: "\uD654\uC0B4\uD45C",
  toolbarAnnotationsText: "\uD14D\uC2A4\uD2B8",
  toolbarAnnotationsTextAnnotations: "\uD14D\uC2A4\uD2B8 \uC8FC\uC11D",
  toolbarAnnotationsTextColor: "\uD14D\uC2A4\uD2B8 \uC0C9\uC0C1",
  toolbarAnnotationsTextSize: "\uD14D\uC2A4\uD2B8 \uD06C\uAE30",
  toolbarAnnotationsTrendLine: "\uCD94\uC138\uC120",
  toolbarAnnotationsUnlock: "\uC7A0\uAE08 \uD574\uC81C",
  toolbarAnnotationsVerticalLine: "\uC138\uB85C \uC120",
  toolbarRange1Month: "1\uAC1C\uC6D4",
  toolbarRange1MonthAria: "1\uAC1C\uC6D4",
  toolbarRange1Year: "1\uB144",
  toolbarRange1YearAria: "1\uB144",
  toolbarRange3Months: "3\uAC1C\uC6D4",
  toolbarRange3MonthsAria: "3\uAC1C\uC6D4",
  toolbarRange6Months: "6\uAC1C\uC6D4",
  toolbarRange6MonthsAria: "6\uAC1C\uC6D4",
  toolbarRangeAll: "\uC804\uCCB4",
  toolbarRangeAllAria: "\uBAA8\uB450",
  toolbarRangeYearToDate: "\uC5F0\uCD08\uBD80\uD130 \uD604\uC7AC\uAE4C\uC9C0",
  toolbarRangeYearToDateAria: "\uC62C\uD574 \uCD08\uBD80\uD130 \uD604\uC7AC\uAE4C\uC9C0",
  toolbarSeriesTypeCandles: "\uCE94\uB4E4",
  toolbarSeriesTypeDropdown: "\uCC28\uD2B8 \uC720\uD615",
  toolbarSeriesTypeHighLow: "\uACE0\uC800",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "\uC18D\uBE48 \uC591\uCD08",
  toolbarSeriesTypeLine: "\uB77C\uC778",
  toolbarSeriesTypeLineWithMarkers: "\uB9C8\uCEE4\uAC00 \uC788\uB294 \uC120",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "\uACC4\uB2E8\uD615 \uC120",
  toolbarZoomPanEnd: "\uB05D\uC73C\uB85C \uC774\uB3D9",
  toolbarZoomPanLeft: "\uC67C\uCABD\uC73C\uB85C \uC774\uB3D9",
  toolbarZoomPanRight: "\uC624\uB978\uCABD\uC73C\uB85C \uC774\uB3D9",
  toolbarZoomPanStart: "\uC2DC\uC791 \uC704\uCE58\uB85C \uC774\uB3D9",
  toolbarZoomReset: "\uC90C \uB9AC\uC14B",
  toolbarZoomZoomIn: "\uD655\uB300",
  toolbarZoomZoomOut: "\uCD95\uC18C",
  tooltipPaginationStatus: "${index}[number] / ${count}[number]"
};
//# sourceMappingURL=ko-KR.cjs.js.map
